import * as React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import banner1 from "../../../assets/innovation/banner_1b.jpg";
import banner2 from "../../../assets/innovation/banner_3b.jpg";
import banner3 from "../../../assets/innovation/banner_4b.jpg";
import banner4 from "../../../assets/innovation/banner_5b.jpg";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const images = [
  {
    label: "banner_image1",
    imgPath: banner1,
    title: "Welcome to the OORC Innovation Hub",
    subtitle:
      "...we help you move from “concept” to “creation” through mentorship, collaboration, and technical incubation..",
  },
  {
    label: "banner_image2",
    imgPath: banner2,
    title: "Building Tomorrow’s Solutions in Ogbomoso.",
    subtitle:
      "...we help you move from “concept” to “creation” through mentorship, collaboration, and technical incubation..",
  },
  {
    label: "banner_image3",
    imgPath: banner3,
    title: "Empowering Innovators to Transform Communities.",
    subtitle:
      "...we help you move from “concept” to “creation” through mentorship, collaboration, and technical incubation..",
  },
  {
    label: "banner_image4",
    imgPath: banner4,
    title: "Innovate Locally. Impact Globally.",
    subtitle:
      "...we help you move from “concept” to “creation” through mentorship, collaboration, and technical incubation..",
  },
];

function Banner() {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <Box sx={{ flexGrow: 1 }} marginTop={{ xs: "15%", sm: "0%" }}>
      <AutoPlaySwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
        interval={7500}
      >
        {images.map((step, index) => (
          <div key={step.label}>
            {Math.abs(activeStep - index) <= 2 ? (
              <Box>
                <Box
                  component="img"
                  height={{ xs: "100vh", sm: "800px" }}
                  sx={{
                    position: "relative",
                    overflow: "hidden",
                    objectFit: "cover",
                    width: "100%",
                  }}
                  src={step.imgPath}
                  alt={step.label}
                />
                <Box
                  display={{ xs: "none", sm: "block" }}
                  paddingBottom={"3%"}
                  position={"absolute"}
                  top={{ xs: "55%", sm: "25%" }}
                  marginLeft={{ xs: "0%", sm: "5%" }}
                  width={"100%"}
                >
                  <Typography
                    variant="h2"
                    color="#F2C844"
                    fontWeight={800}
                    padding={"1% 30% 1% 5%"}
                    fontFamily={"Kaushan Script"}
                    textAlign={"left"}
                  >
                    {step.title}
                  </Typography>
                  <Typography
                    variant={"h6"}
                    fontWeight={600}
                    textAlign={"left"}
                    padding={"1% 40% 1% 5%"}
                    color={"#fff"}
                  >
                    {step.subtitle}
                  </Typography>
                </Box>
                <Box
                  display={{ xs: "block", sm: "none" }}
                  position={"absolute"}
                  top={{ xs: "5%", sm: "25%" }}
                  paddingBottom={"3%"}
                  width={"90%"}
                >
                  <Typography
                    variant="h2"
                    color="#F2C844"
                    fontWeight={700}
                    padding={"40% 3% 1% 6%"}
                    fontFamily={"Kaushan Script"}
                    textAlign={"left"}
                  >
                    {step.title}
                  </Typography>
                  <Typography
                    variant={"h6"}
                    fontWeight={600}
                    textAlign={"left"}
                    padding={"4% 3% 1% 6%"}
                    color={"#fff"}
                  >
                    {step.subtitle}
                  </Typography>
                </Box>
              </Box>
            ) : null}
          </div>
        ))}
      </AutoPlaySwipeableViews>
    </Box>
  );
}

export default Banner;
